<template>
  <div>
    <label v-if="!templateEditing" class="vform-editor-label section">{{ $t("Label") }}</label>
    <original-language-viewer
        v-if="!templateEditing && $store.getters.getSelectedFormLanguage !== 'Unknown'"
        :original-text="element.label.dix['Unknown']"
        class="mb-2"
    />
    <div class="vform-label lighter white non-bold">{{ $store.getters.getSelectedFormLanguage }}</div>
    <div v-if="!templateEditing">
      <div class="col p-0">
        <textarea
            v-model="element.label.dix[$store.getters.getSelectedFormLanguage]"
            :title="element.label.dix['Unknown']"
            class="mb-1 form-text v-form-label form-text-dark"
            type="text"/>
      </div>
    </div>
    <!--Candidate for removal...-->
    <div v-if="!templateEditing" class="dflex mt-3">
      <div class="col row mt-1">
        <label class="vform-editor-label section mt-0">Icon</label>
      </div>
      <div class="dflex col-auto pr-0">
        <div>
          <v-form-image-dix-cell
              :element="element"
              :image-dix="element.label.imageDix"
              :media-category="3"
              :organization-id="organizationId"
              :v-s-t-a-g-e-context="vSTAGEContext"
              preview-size="medium"
          />
        </div>
      </div>
    </div>
    <div
        v-if="!templateEditing && element.label.imageDix[$store.getters.getSelectedFormLanguage] && element.showastiles">
      <label class="vform-editor-label section mt-2">Icon Size</label>

      <label class="section ml-2 vform-editor-body slider-label">{{ element.iconSize }}%</label>
      <slider :default-value="40" :initial-value="element.iconSize"
              :interval="1" :max="100" :min="1"
              @change="(val) => { this.$set(this.element, 'iconSize', val) }"/>
    </div>
    <div v-if="!element.showastiles" class="dflex mt-3">
      <div class="col row">
        <label class="vform-editor-label section mt-0">Alignment</label>
      </div>
      <set-by-template v-if="selectedTemplate.alignment"/>
      <div
          v-for="(align, index) in alignments"
          v-else
          :key="index"
          :class="['vform-alignment-button', align === element.alignment ? 'active' : '']"
          @click="setAlignment(align)">
        <icon :type="'align-' + align" size="1"/>
      </div>
    </div>
    <alignment-editor
        :element="element"
        :selected-template="selectedTemplate"
    />
    <div v-if="!element.showastiles" class="dflex mt-3">
      <div class="col row">
        <label class="vform-editor-label section mt-0">Style</label>
      </div>
      <set-by-template v-if="selectedTemplate.buttonStyle"/>
      <select v-else v-model="element.buttonStyle" class="custom-select form-text-dark">
        <option v-for="(style, index) in buttonStyles" :key="index" :value="style">
          {{ $t("vform.buttonStyle." + style) }}
        </option>
      </select>
      <tile-button
          v-if="!selectedTemplate.iconPos && element.buttonStyle && [buttonStyles.TEXT_AND_ARROW, buttonStyles.TEXT_AND_ICON].includes(element.buttonStyle)"
          :initial-active-tiles="[element.iconPos ? element.iconPos : 'IconsRight']"
          :tiles="['IconsLeft', 'IconsRight']"
          :values="['iconLeft', 'iconRight']"
          class="mt-1"
          @trigger="setIconPos"
      />
      <template v-if="element.buttonStyle === buttonStyles.TEXT_AND_ICON">
        <label class="vform-label white mt-1 mb-0">Please select your icon</label>
        <select class="custom-select form-text-dark" v-model="element.icon">
          <option style="color: #fff;" :key="icon.icon" v-for="icon in icons" :value="icon.icon">{{ icon.name }}</option>
        </select>
        <label class="vform-label white mt-1 mb-0">Selected icon</label>
        <div class="w-100" v-if="element.icon">
          <icon :type="element.icon" />
        </div>
      </template>
    </div>
    <div class="col pl-0 pr-0 dflex">
      <div class="col pl-0">
        <label class="mt-3 vform-editor-label section">{{
            $t("showInline")
          }}</label>
      </div>
      <!--todo: add template thingy??-->
      <div class="col-auto pl-0 pr-0" style="margin: auto">
        <label
            :for="'showInline' + $vnode.key"
            class="container"
            style="padding-left: 5px !important"
        >
          <input
              :id="'showInline' + $vnode.key"
              v-model="element.isInline"
              type="checkbox"
          >
          <span class="checkmark"/>
        </label>
      </div>
    </div>
    <div v-if="showAsTilesIsVisible" class="col pl-0 pr-0 dflex">
      <div class="col pl-0">
        <label class="mt-3 vform-editor-label section">{{
            $t("showAsTile")
          }}</label>
      </div>
      <set-by-template v-if="!templateEditing && !isObjectEmpty(selectedTemplate)"/>
      <div v-else class="col-auto pl-0 pr-0" style="margin: auto">
        <div v-if="true" class="col-12 dflex row">
          <label
              :for="'chkshowastiles' + $vnode.key"
              class="container"
              style="padding-left: 5px !important"
          >
            <input
                :id="'chkshowastiles' + $vnode.key"
                v-model="element.showastiles"
                type="checkbox"
            >
            <span class="checkmark"/>
          </label>
        </div>
      </div>
    </div>
    <div v-if="element.showastiles">
      <label class="vform-editor-label section mt-2">Height</label>
      <select v-model="element.buttonSizeMode" class="custom-select form-text-dark">
        <option v-if="!element.buttonSizeMode" value="" disabled>{{ $t('pleaseSelect') }}</option>
        <option v-for="mode in buttonSizeModes" :key="mode" :value="mode">{{ $t('vform.buttonSizeMode.' + mode) }}</option>
      </select>
      <template v-if="element.buttonSizeMode && element.buttonSizeMode !== 'auto'">
        <label class="section ml-2 mt-3 vform-editor-body slider-label">{{
            element.height ? `${element.height}%` : 'AUTO'
          }}</label>
        <set-by-template v-if="selectedTemplate.height"/>
        <slider v-else :default-value="0" :initial-value="element.height"
                :interval="1" :max="100" :min="0" @change="(val) => { this.$set(this.element, 'height', val) }"></slider>
      </template>
    </div>
    <div class="w-100"/>
    <label class="vform-editor-label section">Background Color</label>
    <set-by-template v-if="!templateEditing && !isObjectEmpty(selectedTemplate)"/>
    <color-picker-and-field
        v-else
        :field-background-color="element.backgroundColor ? element.backgroundColor : null"
        @saveColor="(color) => {setItemColor('backgroundColor', color)}"
        @unsetColor="setItemColor('backgroundColor', null)"
    />

    <label class="vform-editor-label section">Border Color</label>
    <set-by-template v-if="!templateEditing && !isObjectEmpty(selectedTemplate)"/>
    <color-picker-and-field
        v-else
        :field-background-color="element.borderColor"
        @saveColor="(color) => {setItemColor('borderColor', color)}"
        @unsetColor="setItemColor('borderColor', null)"
    />

    <label class="vform-editor-label section">Font Color</label>
    <set-by-template v-if="!templateEditing && !isObjectEmpty(selectedTemplate)"/>
    <color-picker-and-field
        v-else
        :field-background-color="element.fontColor"
        @saveColor="(color) => {setItemColor('fontColor', color)}"
        @unsetColor="setItemColor('fontColor', null)"
    />
    <div
        v-if="(!selectedTemplate.backgroundColor && !selectedTemplate.fontColor && !selectedTemplate.borderColor) && (element.backgroundColor || element.fontColor || element.borderColor)"
        class="clickable darker p-1 border-radius d-inline-block mt-1"
        @click="element.backgroundColor = null; element.fontColor = null; element.borderColor = null;">
      {{ $t('resetColor') }}
    </div>
    <div class="w-100"/>

    <label v-if="!templateEditing" class="vform-editor-label section">Button Type</label>
    <select v-if="!templateEditing" v-model="element.actionMode"
            class="custom-select form-text-dark"
            @change="(e) => {setMode(e.target.value)}">
      <option v-for="mode in vFormButtonActionModes" :key="mode" :value="mode">{{ $t(mode) }}</option>
    </select>
    <condition-editor
        v-if="!templateEditing && element && element.actionMode === vFormButtonActionModes.RULES_BASED"
        :element="element"
        :globals="globals"
        :organization-id="organizationId"
        :project-id="projectId"
        :slides="slides"
        :steps="steps"
        :v-form-config="vformConfig"
        class="mt-2"
    />
    <v-form-go-to-component
        v-else-if="!templateEditing && vFormConfig"
        :current-lang="$store.getters.getSelectedFormLanguage"
        :element="element"
        :organization-id="organizationId"
        :project-id="projectId"
        :slides="slides"
        :steps="steps"
        :v-form-config="vFormConfig"
        default-action="NextSlide"
        @selectedAction="(newSelectedAction) => {selectedAction = newSelectedAction}"
    />
  </div>
</template>

<script>
import {vFormControls, placeholders, vFormButtonActionModes, buttonStyles} from "@/enum";
import vFormImageDixCell from "@/components/vForm/vFormImageDixCell";
import Icon from "../Icon";
import vFormElementMixin from "@/components/vForm/vFormElementMixin.js";
import Slider from "@/components/widgets/editors/Slider";
import vFormGoToComponent from "@/components/vForm/vFormGoToComponent";
import ConditionEditor from "./viewer/ConditionEditor";
import SetByTemplate from "@/components/vForm/SetByTemplate.vue";
import ColorPickerAndField from "@/components/widgets/editors/ColorPickerAndField.vue";
import AlignmentEditor from "@/components/vForm/AlignmentEditor.vue";
import OriginalLanguageViewer from "@/components/vForm/OriginalLanguageViewer.vue";
import TileButton from "@/components/forms/TileButton.vue";

export default {
  name: "vFormBUTTONMixin.js.vue",
  components: {
    TileButton,
    OriginalLanguageViewer,
    ColorPickerAndField,
    SetByTemplate,
    Icon,
    vFormImageDixCell,
    Slider,
    vFormGoToComponent,
    ConditionEditor,
    AlignmentEditor
  },
  mixins: [vFormElementMixin],
  props: {
    thumbs: {type: Object, default: null},
    slides: {type: Array, default: null},
    steps: {type: Array, default: null},
    allowTile: {type: Boolean, default: true},
    templateEditing: {type: Boolean, default: false},
  },
  data() {
    return {
      buttonStyles,
      vFormControls: vFormControls,
      placeholders: placeholders,
      vFormButtonActionModes: vFormButtonActionModes,
      buttonSizeModes: ['auto', 'minheight'],
      forceReRenderKey: 0,
      selectedAction: "NextSlide",
      targetSlide: "",
      alignments: ["left", "center", "right", "justify"],
      textArea: false,
      icons: [{
        icon: 'house',
        name: 'home'
      }, {
        icon: 'gear',
        name: 'options'
      }, {
        icon: 'play',
        name: 'play'
      },{
        icon: 'angle-right',
        name: 'arrow'
      },{
        icon: 'rotate-right',
        name: 'redo'
      },{
        icon: 'check',
        name: 'checkmark'
      },{
        icon: 'flag-checkered',
        name: 'finish'
      }]
    };
  },
  computed: {
    placeholderText() {
      if (this.element.formElementTypeString === this.vFormControls.BUTTON) {
        return this.$t("next");
      }

      return this.$t(this.element.formElementTypeString.toLowerCase());
    },
    showAsTilesIsVisible() {
      return this.allowTile && !this.element.bottomDropZone;
    },
  },
  watch: {
    'element.showastiles'(newVal) {
      if (newVal && !this.element.buttonSizeMode) {
        this.$set(this.element, 'buttonSizeMode', 'auto');
      }
    },
    selectedAction() {
      this.element.selectedAction = this.selectedAction;
      if (this.selectedAction === 'NextSlide') {
        this.element.isCurrentProject = null;
        this.element.linkedProjectId = null;
        this.element.linkedProjectName = null;
        this.element.targetStep = null;
        this.element.targetSlide = null;
      }

      this.forceReRenderKey++;
    },
    targetSlide() {
      this.element.targetSlide = this.targetSlide;
    },
  },
  beforeMount() {
    this.migrateOldButtons();
  },
  methods: {
    migrateOldButtons() {
      console.log('migrateOldButtons');
      if (this.element.selectedAction) {
        this.selectedAction = this.element.selectedAction;
      }
      if (!this.element.iconPos) {
        this.$set(this.element, "iconPos", 'iconRight');
      }

      if (this.element.targetSlide) {
        this.targetSlide = this.element.targetSlide;
      }

      if (!this.element.showastiles) {
        this.$set(this.element, "showastiles", false);
      }

      // Legacy migration: tile buttons without buttonSizeMode default to minheight
      if (this.element.showastiles && !this.element.buttonSizeMode) {
        this.$set(this.element, "buttonSizeMode", 'minheight');
      }

      if (!this.element.alignment) {
        this.$set(this.element, "alignment", "right");
      }

      if (!this.element.buttonStyle) {
        this.$set(this.element, "buttonStyle", "Text");
      }

      if (!this.element.actionMode) {
        this.$set(this.element, "actionMode", "default")
      }
      if (!this.element.conditions) {
        this.$set(this.element, "conditions", [])
      }

      if (!this.element.multiLine) {
        this.$set(this.element, "multiLine", false)
      }

      if (!this.element.backgroundColor) {
        this.$set(this.element, "backgroundColor", null)
      }

      if (this.element.isInline === undefined) {
        this.$set(this.element, "isInline", false)
      }

      if(!this.element.icon) {
        this.$set(this.element, "icon", null);
      }
      console.log('migrateOldButtons done');
    },
    setIconPos(val) {
      const {value} = val;
      this.$set(this.element, "iconPos", value)
    },
    setMode(val) {
      this.$set(this.element, "actionMode", val);
      if (val !== vFormButtonActionModes.RULES_BASED) {
        this.$set(this.element, "rules", []);
      }
    },
    setAlignment(val) {
      this.$set(this.element, "alignment", val);
    },
    setTextAlignment(val) {
      this.$set(this.element, "textAlignment", val);
    },
  },
};
</script>

<style lang="scss">
/*hr {
    margin: 0;
  }*/
.vform-alignment-button {
  background-color: var(--vform-editor-ui-secondary-color);
  border-radius: 1px;
  margin-left: 1px;
  width: 25px;
  height: 25px;
  position: relative;
  color: #fff;

  .icon {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }

  &.active {
    background-color: var(--vform-editor-accent-color);
  }
}

.prop-tab-separator {
  height: 1px;
  background: var(--vform-editor-gizmos-primary-color);
  margin-bottom: -10px;
}

.label-prop-tab-separator {
  margin: 0;
  padding: 0 8px 0 8px;
  color: var(--vform-editor-gizmos-secondary-color);
  background: var(--vform-editor-gizmos-primary-color);
}
</style>
